<div id="dance-room" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Dance & Music Studio</h1>
      <h4 class="fw-semibold text-dark mb-4">"Where Rhythm Meets Expression, and Grace Finds Its Voice"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        The Dance & Music Studio at Shah Satnam Ji Girls College is a vibrant and aesthetically designed space that fosters artistic creativity, musical talent, and performing arts skills. Fully equipped with professional sound systems, acoustics, and dance mirrors, the studio serves as a cradle for future performers.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: #1c5c3e; border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Key Features -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Studio Infrastructure & Amenities</h5>
      <p class="text-muted mb-3">Our studio is structured to support comprehensive learning and practice across various classical and contemporary disciplines:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Professional Wooden Flooring:</strong> Shock-absorbent wood-paneled floors designed specifically to prevent injuries and facilitate smooth dancing routines.</li>
        <li class="mb-2"><strong>Full-length Mirror Wall:</strong> Premium alignment mirrors that allow students to monitor their posture, expressions, and synchronization.</li>
        <li class="mb-2"><strong>Acoustic Instruments:</strong> A rich collection of classical and modern musical instruments including harmoniums, tablas, keyboards, and tanpuras.</li>
        <li class="mb-2"><strong>State-of-the-Art Sound System:</strong> High-fidelity audio system for crystal clear rhythm playback during choreography and practice sessions.</li>
      </ul>

      <!-- Performing Arts Training -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Nurturing Cultural & Classical Talents</h5>
      <p class="text-muted mb-3">We believe in providing professional-grade training that enables students to confidently showcase their abilities on regional and national stages:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Classical Dance Forms:</strong> Specialized coaching in traditional Indian dance forms including Kathak and Bharatnatyam.</li>
        <li class="mb-2"><strong>Folk & Contemporary:</strong> Dynamic choreography workshops covering vibrant regional folk dances (Gidha, Bhangra) and modern style expressions.</li>
        <li class="mb-2"><strong>Vocal & Instrumental Music:</strong> Dedicated sessions for classical vocal training and expertise in multiple acoustic instruments.</li>
      </ul>

      <!-- Video Showcase Section -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Rhythmic Performances & Video Highlights</h5>
      <p class="text-muted mb-4">Watch our students bring melodies and movements to life in recent training sessions and celebrations:</p>
      <div class="row g-4 justify-content-center mb-5">
        <div class="col-12 col-md-6" *ngFor="let video of danceVideos">
          <div class="ratio ratio-16x9 rounded-4 overflow-hidden shadow-sm" style="border: 1px solid #eee;">
            <video [src]="video.src" controls class="w-100 h-100" style="object-fit: cover; background: #000;"></video>
          </div>
          <p class="text-center mt-2 fw-semibold text-muted" style="font-size: 14px;">{{ video.title }}</p>
        </div>
      </div>

      <!-- Studio Gallery Section -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Studio Gallery Showcase</h5>
      <p class="text-muted mb-4">Browse through captured moments of dedication, practice, and performing arts excellence inside the studio:</p>
      <div class="row g-3 justify-content-center mb-4">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of danceImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Dance & Music Studio Practice" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View Studio</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Inspiration Quote Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"To dance is to be out of yourself. Larger, more beautiful, more powerful."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">A dedicate hub of rhythm, culture, and artistic creation helping students reach new creative heights.</p>
      </div>

    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Studio View">
      </div>
    </div>

  </div>
</div>

